import { getJson, getString } from 'shared-base';

const texturesResolution = getString('TEXTURE_RESOLUTION') || '256';
const savedSettings = getJson('SETTINGS');

export const settings: ISettings = {
  sortGeneratorsById: false,
  whiteThumbnails: true,
  texturesResolution: texturesResolution as TexturesResolution,
  openAiKey: '',
  unityVersion: 'stable',
  firstPage: 'generators',
  ...savedSettings,
};
